import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => {
    return {
        root: {
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '12px',
            border: `1px solid ${theme.palette.grey[400]}`
        },
        openBtn: {
            width: '100%',
            height: '100%',
        },
        // CustomCollapse
        accordionHeader: {
            background: theme.palette.info.main,
            color: theme.palette.common.white,
            borderRadius: theme.spacing(1, 1, 0, 0),
            padding: theme.spacing(1, 2),
        },
        summary: {
            position: "relative",
            border: `1px solid ${theme.palette.grey[400]}`,
            borderTop: "none",
            padding: theme.spacing(2),
            cursor: "pointer",
        },
        toggleBtn: {
            position: "absolute",
            top: theme.spacing(2),
            right: theme.spacing(2),
            " & button": {
                background: theme.palette.info.main,
                color: theme.palette.common.white,
                transition: theme.transitions.easing.easeIn,
                "&:hover": {
                    background: theme.palette.info.main,
                    color: theme.palette.common.white,
                }
            },
        },
        boxShadow: {
            boxShadow: '0 8px 6px -6px rgba(0,0,0,0.25)',
        },
        // TrendView styles
        trendView: {
            height: theme.spacing(3),
            width: theme.spacing(3),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: theme.spacing(0.5),
            padding: theme.spacing(2)
        }
    };
});
